'use strict';

var lp = require('it-length-prefixed');

var it = require('./it');

var toBuffer = require('it-buffer');

module.exports.encode = function (proto) {
  return function (source) {
    return lp.encode()(it.encode(proto)(source));
  };
};

module.exports.decode = function (proto) {
  return function (source) {
    return it.decode(proto)(toBuffer(lp.decode()(source)));
  };
};

module.exports.it = it;